export function getErrorMessage(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object" && detail.message) return detail.message;
  return fallback;
}

export function getErrorCode(err) {
  const detail = err?.response?.data?.detail;
  return detail && typeof detail === "object" ? detail.code : null;
}
